import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { SettingsProvider } from './components/layout/Settingscontext';
import MusicManager         from './components/layout/MusicManager';

import Levels from './pages/levels';
import Splash from './pages/splash';
import Intro from './pages/Intro';
import Characters from './pages/characters'
import Error404 from './pages/Error404';
import Lvl1 from './pages/lvl1';
import Lvl2 from './pages/lvl2';
import Victory from './pages/victory';
import Defeat from './pages/defeat';
import LevelRunner from './pages/LevelRunner';

function Paths() {
  return (
    <SettingsProvider>
      <MusicManager />
      
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Intro />} />
            <Route path="/splash" element={<Splash />} />
            <Route path="/levels" element={<Levels />} />
            <Route path="/level1" element={<Lvl1 />} />
            <Route path="/level2" element={<Lvl2 />} />
            <Route path="/level/:id" element={<LevelRunner />} />
            <Route path="/characters" element={<Characters />} />
            <Route path="/victory" element={<Victory />} />
            <Route path="/defeat" element={<Defeat />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </BrowserRouter>
    </SettingsProvider>
  );
}

export default Paths;